import type { InvoiceConfig } from "@/interfaces/invoiceConfig";

/**
 * Invoice configuration for OneFit club.
 * Filename matches club slug: onefit
 */
export const onefitInvoiceConfig: InvoiceConfig = {
  title: "FACTURE",
  headerText: "Centre de fitness OneFit",
  footerText:
    "Merci pour votre confiance. Nous vous remercions de votre fidélité.", 
  signatureLabel: "Signature",
  forClubLabel: "Pour le club",
};
